import DashboardCount from "../../slices/dashboard/DashboardCount";
import dashboardNotice from "../../slices/dashboard/DashboardNotice";
import dashboardTicket from "../../slices/dashboard/DashboardTicket";
import dashboardPoll from "../../slices/dashboard/DashboardPoll";
import xpressAdminDashboard from "../../slices/dashboard/XpressAdminDashboard";
import superAdminDashboard from "../../slices/dashboard/SuperAdminDashboard";

const dashboardReducer = {
    dashboardCount: DashboardCount,
    dashboardNotice: dashboardNotice,
    dashboardTicket: dashboardTicket,
    dashboardPoll: dashboardPoll,
    xpressAdminDashboard,
    superAdminDashboard,
};

export default dashboardReducer;